import { useState } from 'react'

const useSimpleDialog = () => {
  const [showDialog, setShowDialog] = useState(false)

  const handleClose = () => {
    setShowDialog(false)
  }

  const handleOpen = () => {
    setShowDialog(true)
  }

  return { showDialog, handleOpen, handleClose }
}
export default useSimpleDialog
